<template>
    <div class="block bg-white hover:bg-gray-50 border-2 transition-colors group/card relative">
        <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
                <!-- Main info area linked to show page -->
                <Link :href="route('advisors.apartments.show', apartment.uuid)" class="flex-1 min-w-0 pr-4">
                    <p class="text-sm text-minplan-blue flex">
                        <FolderIcon class="mr-3 h-5 w-5 text-gray-500" />
                        <strong>{{ apartment.name }}</strong>
                        <span v-if="apartment.deadlineColor && $page.props.deadline_indicator_show_in_apartment_dashboard" class="inline-flex items-center ml-2 px-1.5 rounded-full text-[15px] font-large bg-gray-100 cursor-help" 
                            :title="getDeadlineTooltip(apartment.deadlineColor)">
                            <span class="h-2 w-2 rounded-full mr-1" :style="{ backgroundColor: apartment.deadlineColor }"></span>
                            <span :style="{ color: apartment.deadlineColor }">{{ apartment.pendingCount }}</span>
                        </span>
                        <span class="hidden md:inline text-minplan-grey ml-2">{{ apartment.rooms }} {{ $t('apartments.rooms') }} {{ apartment.floor }} | {{ apartment.area }} &#13217;<template v-if="apartment.parking"> | {{ $t('apartments.parking') }} {{ apartment.parking }}</template></span>
                    </p>
                </Link>

                <div class="ml-2 flex-shrink-0 flex items-center space-x-4">
                    <!-- State Badge -->
                    <p class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" :class="[apartment.state === 'active' ? 'bg-lime-100 text-lime-800' : 'bg-gray-100', 'text-gray-800']">
                        {{ $t("states." + apartment.state) }}
                    </p>

                    <!-- Chat Link (Separate) -->
                    <Link 
                        v-if="['owner', 'manager', 'advisor'].includes($page.props.user.currentAgencyRole)"
                        :href="route('advisors.apartments.chat', { apartment: apartment.uuid, buyer: apartment.buyers?.[0]?.id })" 
                        class="relative group/chat p-1 hover:bg-blue-50 rounded-lg transition-all"
                        title="Go to Chat"
                    >
                        <ChatIcon class="h-5 w-5 text-gray-400 group-hover/chat:text-blue-500 transition-colors" />
                        <span v-if="apartment.unread_count" class="absolute -top-1 -right-1 bg-red-500 text-white text-[9px] font-bold px-1 py-0.5 rounded-full ring-1 ring-white">
                            {{ apartment.unread_count }}
                        </span>
                    </Link>

                    <!-- Detailed link (Arrow) -->
                    <Link :href="route('advisors.apartments.show', apartment.uuid)" class="p-1 hover:bg-gray-100 rounded-lg transition-all">
                        <ChevronRightIcon class="h-5 w-5 text-gray-500" />
                    </Link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ChevronRightIcon, FolderIcon, ChatIcon } from "@heroicons/vue/outline";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    emits: [],
    props: ["apartment", "project"],
    name: "ProjectsApartmentsCard.vue",
    components: { ChevronRightIcon, FolderIcon, ChatIcon, Link },
    methods: {
        getDeadlineTooltip(color) {
            const colors = this.$page.props.deadline_colors;
            const threshold = this.$page.props.deadline_threshold;
            if (color === colors.overdue) {
                return this.$t('deadlines.overdue');
            } else if (color === colors.nearing) {
                return this.$t('deadlines.nearing', { threshold });
            } else if (color === colors.on_track) {
                return this.$t('deadlines.on_track', { threshold });
            } else if (color === colors.no_due_date) {
                return this.$t('deadlines.no_due_date');
            }
            return '';
        }
    }
};
</script>

<style scoped></style>
